interface CloseButtonProps {
  handleClear: () => void;
}

const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9851 8.72189L16.7071 15.9999L23.9851 23.2779L23.2781 23.9849L16.0001 16.7069L8.72214 23.9849L8.01514 23.2779L15.2931 15.9999L8.01514 8.72189L8.72214 8.01489L16.0001 15.2929L23.2781 8.01489L23.9851 8.72189Z"
      fill="#6A6A6A"
    />
  </svg>
);

export const CloseButton = ({ handleClear }: CloseButtonProps) => {
  return (
    <button
      onClick={handleClear}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '16px',
      }}
      aria-description="Clear search input"
      aria-label="Clear search input"
    >
      {/* Close button */}
      <CloseIcon />
    </button>
  );
};
